import { createSelector } from 'reselect'
import { IStore } from '../../index'

export const getRooms = createSelector(
  // Input selector
  (state: IStore) => state.bookingCalendar.rooms,

  // Result function
  rooms => {
    return rooms.filter((obj, index, self) => {
      return index === self.findIndex(other => other.id === obj.id)
    })
  },
)
